<template>
  <div class="container" style="font-size:18pt">
    <div class="row">
      <div class="col">
        <h4>{{formulario.titulo}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <p> {{formulario.descricao}}</p>
      </div>
    </div>

  <div class="row" v-if="formulario.perguntas">
    <div class="col">
      <Perguntas :formulario="formulario" />
    </div>
  </div>
  </div>
</template>

<script>

import Perguntas from '../PerguntasComponent/Perguntas'
export default {
  name: 'FormularioVotacao',
  props: ['formulario'],
  components: {Perguntas},
  mounted () {

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Formularios/FormularioVotacao.vue